module.exports = __webpack_public_path__ + "static/media/fallback_Ingredient_img.bf0914d2.png";